<template>
  <div>
    <DHeader />
    <b-row class="ml-3">
      <b-col>
    <p class="action_link" @click="backToSetting()"> <b-icon icon="arrow-left-circle" aria-hidden="true"></b-icon>ย้อนกลับ</p>
      </b-col>
    </b-row>
    <b-row class="text-center">
      <b-col>
        <p class="header-text"> รายการสถานีตำรวจเพื่อใช้ในการเลือกกรอกแบบฟอร์ม</p>
      </b-col>
    </b-row>
    <div class="mt-5">
      <b-tabs content-class="mt-3" justified>
        <b-tab title="สถานีตำรวจที่เลือก" @click="getListPoliceStationByHospital(user.hospcode)" id="hospital_selected" active >
          <div class="setting_list_police">
            <template v-if="this.items_hospital_selected.length>0">
                  <b-table
                      :filter="filter"
                      :fields="fields_hospital_selected"
                      :items="items_hospital_selected"
                      class="mx-auto text-center table-responsive "
                      hover
                      responsive="lg"
                      style="width: 60%; white-space: nowrap"
                  >
                    <template #cell(action)="row">
                      <b-button class="btn btn-outline-danger btn-delete" @click="deletePoliceStation(row.item.id,row.item.police_station)">
                        <b-icon icon="trash"></b-icon>
                        ลบ
                      </b-button>
                    </template>
                    <template #cell(no)="row">
                      {{ row.index + 1 }}
                    </template>
                  </b-table>
            </template>
            <template v-else>
              <b-row class="text-center">
                <b-col>
                  <p class="header-text"> ไม่พบข้อมูลสถานีตำรวจ</p>
                </b-col>
              </b-row>
            </template>
          </div>
        </b-tab >
        <b-tab title="รายการสถานีตำรวจ" @click="getPoliceStationByprovince(user.hospital_province)" id="list_police_station"  >
          <b-row class=" text-center ">
            <b-col md="4" offset-lg="4">
              <multiselect id="location_province_id"
                           :options="optionProvince"
                           class="multiselect-style2 my-3"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกจังหวัด"
                           select-label=""
                           selectedLabel=""
                           track-by="name"
                           @input="getPoliceStationByprovince(province_select.code)"
                           @select="(opt) =>(province_select = opt.code)"
                           v-model="province_select"
              />
            </b-col>
          </b-row>
          <div class="setting_list_police">
            <template v-if="this.items_all.length>0">
              <b-table
                  :filter="filter"
                  :fields="fields_all"
                  :items="items_all"
                  class="mx-auto text-center"
                  hover
                  responsive="lg"
                  style="width: 60%; white-space: nowrap"
              >
                <template v-slot:head(action)>
                  <b-form-checkbox
                      name="checkbox-1"
                      @change="selecetAll()"
                      v-model="is_checkALl"
                  >เลือกทั้งหมด
                  </b-form-checkbox>
                </template>
                <template #cell(action)="row" v-if="selected">
                  <span v-if="checkSelected(row.item.id)"> เลือกแล้ว</span>
                  <span v-else>
                      <b-form-checkbox
                          name="checkbox-1"
                          @change="saveToList(row.item.id)"
                          class="mx-1"
                      >
                  </b-form-checkbox>
                                      </span>
                </template>
                <template #cell(action)="row" v-else>
                      <b-form-checkbox
                          name="checkbox-1"
                          @change="saveToList(row.item.id)"
                          class="mx-1"
                      >
                  </b-form-checkbox>
                </template>

                <template #cell(no)="row">
                  {{ row.index + 1 }}
                </template>
              </b-table>
            </template>
            <template v-else>
              <b-row class="text-center">
                <b-col>
                  <p class="header-text"> ไม่พบข้อมูลสถานีตำรวจ</p>
                </b-col>
              </b-row>
            </template>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <DFooter />
  </div>

</template>

<script>
import {mapState} from 'vuex'
import DHeader from "@/components/Header";
import DFooter from "@/components/Footer";
import Swal from "sweetalert2";
export default {
  name: "SettingListPoliceStation",
  components:{
    DHeader,
    DFooter,
  },
  data(){
    return {
      province_select:"",
      filter:'',
      items_all:[],
      fields_all:[],
      items_hospital_selected:[],
      fields_hospital_selected:[],
      list_all_police_station:[],
      is_checkALl:false,
      selected:false
    }
  },
  created() {
    this.prepareData();
  },
  computed:{
    ...mapState({
      user: state => state.Auth.users,
      listAllPoliceStation: state => state.Police.police_station,
      optionProvince:state => state.Common.provinces,
      selectedPoliceStation:state => state.Police.police_station_for_hospital
    }),
  },
  methods:{
    async prepareData(){
    await this.$store.dispatch("Police/setPolice")
    await this.getListPoliceStationByHospital(this.user.hospcode)
    },
    generateTable(){
     if (this.list_all_police_station){
       this.items_all=[];
       this.list_all_police_station.forEach(item=>{
         let data = {
           id:item.id,
           police_station: item.name,
           province: item.province,
         }
         this.items_all.push(data)
       })
       this.fields_all=[
         { key:'action',label:'เลือก',tdClass:'w-25'},
         { key:'id',label:'',thClass: 'd-none', tdClass: 'd-none'},
         { key: "no", label: "ลำดับ" ,tdClass:'w-25'},
         { key: "police_station", label: "สถานีตำรวจ", sortable: true,tdClass:'w-25 text-left' },
         { key: "province", label: "จังหวัด", sortable: true,tdClass:'w-25' },
       ];
     } else {
       this.items_all =[];
     }
    },
    generateTableListPoliceStation(){
     if (this.selectedPoliceStation){
       this.items_hospital_selected=[];
       this.selected =true;
       this.selectedPoliceStation.forEach(item=>{
         let data = {
           id:item.id,
           police_station: item.Police_station_name,
           province: item.Police_station_province_name,
         }
         this.items_hospital_selected.push(data)
       })
       this.fields_hospital_selected=[
         { key:'action',label:'จัดการ',tdClass:'w-auto'},
         { key:'id',label:'',thClass: 'd-none', tdClass: 'd-none'},
         { key: "no", label: "ลำดับ" ,tdClass:'auto'},
         { key: "police_station", label: "สถานีตำรวจ", sortable: true ,tdClass:'w-50'},
         { key: "province", label: "จังหวัด", sortable: true ,tdClass:'w-25'},
       ];
     }else {
       this.items_hospital_selected =[];
       this.selected =false;
     }
    },
    saveToList(id_policeStation){
     let data={
       hospital_code : this.user.hospcode,
       police_station: id_policeStation
     }
      this.$store.dispatch('Police/updatePoliceStation',data).then(async () => {
        await Swal.fire({
          icon: "success",
          title: "สำเร็จ"
        })
        this.is_checkALl = false;
        window.location.reload(true);
      })
    },
    getPoliceStationByprovince(province_code){
     if (typeof (province_code) != "string"){
        province_code = province_code.toString();
     }
      let temp_police_station=[];
      temp_police_station.push(this.listAllPoliceStation.filter(item=>{
          return item.province_code == province_code;
      }))
      this.list_all_police_station = temp_police_station[0];
      this.generateTable();
    },
    getListPoliceStationByHospital(hospital_code){
        this.$store.dispatch('Police/onGetListPoliceStation',hospital_code).then((res)=>{
          if (res.length>0) {
            this.generateTableListPoliceStation();
            console.log("selectedPoliceStation", this.selectedPoliceStation)
          }
        })
    },
    deletePoliceStation(police_station_id,police_station_name){
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
      })

      swalWithBootstrapButtons.fire({
        title: 'ยืนยันการลบ?',
        // text: "ต้องการลบ"+' "'police_station_name,
        html:`<b class="text-danger">${police_station_name}</b>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          let data={
            hospitalCode:this.user.hospcode,
            police_station_id:police_station_id
          }
          this.$store.dispatch('Police/onDeletePoliceStation',data).then((res)=>{
            if (res){
              Swal.fire({
                title:'ลบเรียบร้อย',
                icon:'success'
              })
              this.generateTableListPoliceStation();
            }
          });
        } else if (
            result.dismiss === Swal.DismissReason.cancel
        ) {
          Swal.close();
        }
      })
    },
    backToSetting(){
      const path = `/setting`
      if (this.$route.path !== path) this.$router.push(path)
    },
    async  selecetAll(){
      this.is_checkALl = !this.is_checkALl
      let province_code = this.province_select!=="" ? this.province_select.code:this.user.hospital_province
      if (typeof (province_code) != "string"){
        province_code = province_code.toString();
      }
      console.log("province_code",province_code)
      let temp_police_station=[];
      temp_police_station.push(this.listAllPoliceStation.filter(item=>{
        return item.province_code === province_code;
      }))
      console.log("temp_police_station[0]",temp_police_station[0])

      for (const item of temp_police_station[0]) {
        const index = temp_police_station[0].indexOf(item);
        let data={
          hospital_code : this.user.hospcode,
          police_station: item.id
        }
        this.$store.dispatch('Police/updatePoliceStation',data)
        if (index+1 == temp_police_station[0].length){
        await Swal.fire({
           icon:"success",
           title:"สำเร็จ"
         })
          this.is_checkALl =false;
          window.location.reload(true);
        }
      }
  },
    checkSelected(id){
     let temp = this.selectedPoliceStation.filter(item=>{
        return item.Police_station_id == id
      })
      console.log("temp",temp)
      return temp.length > 0 ?true:false
    }

  }

}
</script>

<style scoped>
.setting_list_police{
  height: 100%;
  min-height: 100vh;
}
p{
  color: #2DA1A9;
}
.header-text{
  font-size: 24px;
}
.action_link{
  color: #2DA1A9;
  font-size: 18px;
}
.action_link:hover{
  color: #247980;
}
.btn-delete:hover{
  color: white;
  background-color: red;
}
.btn-delete{
  color: red;
  background-color: white;
}
</style>
